"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useModelDocById(Model, id, raw) {
  var _a = react_1.useState(0),
      count = _a[0],
      setCount = _a[1];

  react_1.useEffect(function () {
    if (!id) {
      return;
    }

    return Model.subscribeChangeById(id, function () {
      setCount(function (x) {
        return x + 1;
      });
    });
  }, [Model, id, raw]);
  return react_1.useMemo(function () {
    if (!id) return null;
    return Model.findByIdSync(id, raw);
  }, [Model, id, raw, count]);
}

exports.useModelDocById = useModelDocById;

function useModelDocByQuery(Model, query, queryOptions) {
  var _a = react_1.useState(0),
      count = _a[0],
      setCount = _a[1];

  var stringifiedQuery = JSON.stringify(query);
  var stringifiedQueryOptions = JSON.stringify(queryOptions);
  react_1.useEffect(function () {
    if (!query) {
      return;
    }

    return Model.subscribeOneDocChangeByQuery(query, queryOptions || {}, function () {
      setCount(function (x) {
        return x + 1;
      });
    });
  }, [Model, stringifiedQuery, stringifiedQueryOptions]);
  return react_1.useMemo(function () {
    if (!query) return null;
    return Model.findOneSync(query, queryOptions);
  }, [Model, stringifiedQuery, stringifiedQueryOptions, count]);
}

exports.useModelDocByQuery = useModelDocByQuery;

function useModelDocsByQuery(Model, query, queryOptions) {
  var _a = react_1.useState(0),
      count = _a[0],
      setCount = _a[1];

  var stringifiedQuery = JSON.stringify(query);
  var stringifiedQueryOptions = JSON.stringify(queryOptions);
  react_1.useEffect(function () {
    if (!query) {
      return;
    }

    return Model.subscribeManyDocsChangeByQuery(query, queryOptions || {}, function () {
      setCount(function (x) {
        return x + 1;
      });
    });
  }, [Model, stringifiedQuery, stringifiedQueryOptions]);
  return react_1.useMemo(function () {
    if (!query) return null;
    return Model.findManySync(query, queryOptions);
  }, [Model, stringifiedQuery, stringifiedQueryOptions, count]);
}

exports.useModelDocsByQuery = useModelDocsByQuery;

function useModelDocsByIds(Model, ids, raw) {
  var _a = react_1.useState(0),
      count = _a[0],
      setCount = _a[1];

  var stringifiedIds = JSON.stringify(ids);
  react_1.useEffect(function () {
    if (!ids) {
      return;
    }

    return Model.subscribeManyDocsChangeByIds(ids, raw, function () {
      setCount(function (x) {
        return x + 1;
      });
    });
  }, [Model, stringifiedIds, raw]);
  return react_1.useMemo(function () {
    if (!ids) return null;
    return Model.findManyByIdsSync(ids, raw);
  }, [Model, stringifiedIds, raw, count]);
}

exports.useModelDocsByIds = useModelDocsByIds;

function useModelDocs(Model, raw) {
  var _a = react_1.useState(0),
      count = _a[0],
      setCount = _a[1];

  react_1.useEffect(function () {
    return Model.subscribeChange(function () {
      setCount(function (x) {
        return x + 1;
      });
    });
  }, [Model, raw]);
  return react_1.useMemo(function () {
    return Model.getAllSync(raw);
  }, [Model, raw, count]);
}

exports.useModelDocs = useModelDocs;